import { ChangeLogKeyType } from '@/components/ChangeLog/constant';

export interface UpdateBannerItem {
  /* 변경사항 페이지에서 열어줄 업데이트 키 */
  tab: ChangeLogKeyType;
  /* 카드에 노출할 한 줄 설명 */
  description: string;
}

/**
 * 좌측 하단에 띄울 업데이트 배너 목록. 최신순으로 작성한다.
 * 한 개만 두면 단독 카드로, 여러 개를 두면 카드가 겹쳐 쌓인 형태로 노출되며
 * 배열의 첫 번째(최신) 항목이 가장 앞에 보이고 이전 버전은 뒤로 겹친다.
 * 카드마다 닫기 버튼이 있어 버전별로 각각 숨길 수 있다.
 */
export const UPDATE_BANNERS: UpdateBannerItem[] = [
  {
    tab: 'update_1.39.0',
    description:
      '공유 링크가 더 짧아졌습니다. 원하는 주소의 커스텀 링크도 설정해 보세요.',
  },
  {
    tab: 'update_1.38.0',
    description:
      '이메일 발송부터 오픈·클릭·콘텐츠 열람 반응까지, 세일즈클루에서 한 번에 확인하세요.',
  },
  {
    tab: 'update_1.37.0',
    description:
      '이제 PDF 위에 YouTube·Vimeo 동영상을 더해 고객에게 전달해 보세요!',
  },
];

export const CHANGE_LOG_PATH = '/change-log';

/* 기존 저장값을 유지하기 위해 'update_1.37.0' -> 'hideUpdateBanner:v1.37.0' 형태를 그대로 사용한다. */
export const getStorageKey = (tab: ChangeLogKeyType) =>
  `hideUpdateBanner:v${tab.replace('update_', '')}`;
